import defaultClient from '@/plugins/axios/defaultClient'

export default {
  getChoicesByKey(key) {
    return defaultClient.get(`/choices/${key}`)
  },
}
